import React from 'react'
import Header from "../components/header/header";
import SocialMedia from "../sections/SocialMedia/SocialMedia"
import Footer from "../components/footer/footer";
function Socialmedia() {
    return (
        <>
        <Header />
        <SocialMedia />
        <Footer />
    </>
    )
}

export default Socialmedia
